// import React, { useState } from "react";
// import { AssignUserRole } from "../../../api/userService";
// import { ToastMain } from "../Master";
// import { Link, useNavigate } from "react-router-dom";
// import Header from "../header";
// import Nav from "../nav";

// const entityFields = [
//   "All",
//   "View",
//   "Add",
//   "Update",
//   "Followup",
//   "Import",
//   "Export",
//   "Delete"
// ];

// const entities = [
//   "Enquiry",
//   "Batches",
//   "Students",
//   "Students Test Report",
//   "Attendance",
//   "Fee Collection",
//   "Kits",
//   "Leaves",
//   "Faculty",
//   "Marketings",
//   "Hostel Management",
//   "Expense Reports",
//   "Courses"
// ];

// function PermissionsForm() {
//   const [permissions, setPermissions] = useState(() => {
//     const initial = {};
//     entities.forEach((entity) => {
//       initial[entity] = {};
//       entityFields.forEach((field) => {
//         initial[entity][field] = false;
//       });
//     });
//     return initial;
//   });

//   const navigate = useNavigate()
//   const createRole = async (e) => {
//     e.preventDefault();
//     const title = e.target.title.value;

//     const finalPermissions = { title };

//     Object.entries(permissions).forEach(([entity, fields]) => {
//       Object.entries(fields).forEach(([field, value]) => {
//         if (field === "All") return;
//         const key = `${entity.toLowerCase().replace(/ /g, "_")}_${field.toLowerCase()}`;
//         finalPermissions[key] = value ? 1 : 0;
//       });
//     });

//     try {
//       const response = await AssignUserRole(finalPermissions);
//       if (response.data?.status) {
//         ToastMain.fire({
//           icon: "success",
//           title: "Successfully created"
//         }).then(()=>{
//           navigate('/role')
//         })
//       } else {
//         ToastMain.fire({
//           icon: "info",
//           title: response.data.message || "Something went wrong"
//         });
//       }
//     } catch (error) {
//       ToastMain.fire({
//         icon: "error",
//         title: error.response?.data?.message || "Something went wrong"
//       });
//     }
//   };

//   const togglePermission = (entity, field) => {
//     setPermissions((prev) => ({
//       ...prev,
//       [entity]: {
//         ...prev[entity],
//         [field]: !prev[entity][field]
//       }
//     }));
//   };

//   const toggleGlobalField = (field) => {
//     const updated = { ...permissions };
//     entities.forEach((entity) => {
//       if (field === "Followup" && entity !== "Enquiry" && entity !== "Students") return;
//       updated[entity][field] = !permissions[entity][field];
//     });
//     setPermissions(updated);
//   };

//   const toggleEntityAll = (entity) => {
//     const updated = { ...permissions };
//     const newValue = !permissions[entity]["All"];
//     entityFields.forEach((field) => {
//       if (field === "Followup" && entity !== "Enquiry" && entity !== "Students") return;
//       updated[entity][field] = newValue;
//     });
//     setPermissions(updated);
//   };

//   return (
//     <div className="layout-wrapper layout-content-navbar">
//             <div className="layout-container">
//               <Header />
//               <div className="layout-page">
//                 <Nav />
//                 <div className="container"></div>
//     <div className="container my-5">
//       <div className="card shadow-lg p-4 rounded-4 border-0">

// <div className="d-flex justify-content-between"><h4 className="mb-4 text-center fw-bold text-primary">Create User Role</h4> <Link
//                       to={"/role"}
//                       className="btn btn-sm btn-outline-primary mb-4"
//                     >
//                       <i className="bi bi-arrow-left-circle me-1"></i> Back
//                     </Link></div>
//         <form onSubmit={createRole}>
//           {/* Title Input */}
//           <div className="mb-4 form-floating form-floating-outline col-md-6">
//             <input
//               type="text"
//               className="form-control"
//               id="title"
//               name="title"
//               placeholder="Enter role name (e.g., Admin, Manager)"
//               required
//             />
//             <label>Role Title</label>
//           </div>

//           {/* Global Permissions */}
//           {/* <div className="mb-5">
//             <h5 className="mb-3 fw-bold text-secondary">Global Permissions</h5>
//             <div className="row gy-2">
//               {entityFields.map((field) => (
//                 <div className="col-6 col-md-3" key={field}>
//                   <div className="form-check">
//                     <input
//                       type="checkbox"
//                       className="form-check-input"
//                       checked={
//                         entities.every((entity) =>
//                           field === "Followup"
//                             ? entity === "Enquiry" || entity === "Students"
//                               ? permissions[entity][field]
//                               : true
//                             : permissions[entity][field]
//                         )
//                       }
//                       onChange={() => toggleGlobalField(field)}
//                       id={`global_${field}`}
//                     />
//                     <label htmlFor={`global_${field}`} className="form-check-label">
//                       {field}
//                     </label>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div> */}

//           {/* Entity Table */}
//           <div className="table-responsive mb-4">
//             <table className="table table-bordered text-center align-middle shadow-sm">
//               <thead className="table-primary position-sticky top-0 z-1">
//                 <tr>
//                   <th className="bg-primary text-white">Entity</th>
//                   {entityFields.map((field) => (
//                     <th className="bg-primary text-white" key={field}>{field}</th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {entities.map((entity) => (
//                   <tr key={entity}>
//                     <td className="fw-semibold">{entity}</td>
//                     {entityFields.map((field) => (
//                       <td key={field}>
//                         {field === "Followup" &&
//                         entity !== "Enquiry" &&
//                         entity !== "Students" ? (
//                           <span className="text-muted">–</span>
//                         ) : field === "All" ? (
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             checked={permissions[entity]["All"]}
//                             onChange={() => toggleEntityAll(entity)}
//                           />
//                         ) : (
//                           <input
//                             type="checkbox"
//                             className="form-check-input"
//                             checked={permissions[entity][field]}
//                             onChange={() => togglePermission(entity, field)}
//                           />
//                         )}
//                       </td>
//                     ))}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           {/* Submit Buttons */}
//           <div className="d-flex justify-content-end gap-3">
//             <button type="reset" className="btn btn-outline-warning px-4">
//               Reset
//             </button>
//             <button type="submit" className="btn btn-sm btn-outline-primary px-4 shadow">
//               Save Role
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//     </div>
//     </div>
//     </div>
//   );
// }

// export default PermissionsForm;


import React, { useEffect, useState } from "react";
import axios from "axios";
import { AssignRole, GetManegment, GetRoute } from "../../../api/UserRoleServices";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { ToastMain ,SweetAlertShow} from "../../master/Master";
import { useNavigate } from "react-router-dom";
import UserHeader from "./UserHeader";

const RolePermissionForm = () => {
  const [entities, setEntities] = useState([]);
  const [entityFields, setEntityFields] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('')
  const navigate = useNavigate();

  useEffect(() => {
    fetchEntities();
    fetchEntityFields();
  }, []);

  const roleAssign = async (e) => {
    setLoading(true)
    e.preventDefault();

    const formData = new FormData(e.target);
    const name = formData.get("name");

    const permissions = Object.entries(selectedPermissions).map(
      ([management_id, routes]) => ({
        management_id: Number(management_id),
        route_ids: routes.map((r) => r.id),
      })
    );
    try {
      const response = await AssignRole({
        name: name,
        permissions: permissions,
      });
      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: "Permissions saved successfully!",
        });
        navigate("/role");
      } else {
        if (response?.data?.errors) {
          setError(response?.data?.errors)
        }
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || "Something went wrong",
        // });
        SweetAlertShow('info','Warning', response?.data?.message)
      }

    } catch (error) {
      if (error?.response?.data?.errors) {
        setError(error?.response?.data?.errors)
      }
      // ToastMain.fire({
      //   icon: "error",
      //   title: error?.response?.data?.message || "Something went wrong",
      // });

      SweetAlertShow('error','Error', error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false)
    }
  };



  const fetchEntities = async () => {
    setLoading(true)
    try {
      const res = await GetManegment();
      if (res.data.status) {
        setEntities(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching entities", error);
    } finally {
      setLoading(false)
    }
  };

  const fetchEntityFields = async () => {
    setLoading(true)
    try {
      const res = await GetRoute();
      if (res?.data?.data) {
        const grouped = groupFieldsByEntity(res.data.data);
        setEntityFields(grouped);
      }
    } catch (error) {
      console.error("Error fetching entity fields", error);
    } finally {
      setLoading(false)
    }
  };

  const groupFieldsByEntity = (fields) => {
    const grouped = {};
    fields.forEach((field) => {
      const key = field.managment_id;
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push({ id: field.id, name: field.name }); // ✅ Object भेजो
    });
    return grouped;
  };

  const handleCheckboxChange = (entityId, fieldObj) => {
    setSelectedPermissions((prev) => {
      const current = prev[entityId] || [];
      const alreadySelected = current.find((f) => f.id === fieldObj.id);

      const updated = alreadySelected
        ? current.filter((f) => f.id !== fieldObj.id)
        : [...current, fieldObj];

      return { ...prev, [entityId]: updated };
    });
  };

  const handleSelectAll = (entityId) => {
    const allFields = entityFields[entityId] || [];
    const allSelected =
      selectedPermissions[entityId]?.length === allFields.length;
    setSelectedPermissions((prev) => ({
      ...prev,
      [entityId]: allSelected ? [] : [...allFields],
    }));
  };

  const handleSubmit = async () => {
    try {
      await axios.post("/api/save-role-permissions", {
        permissions: selectedPermissions,
      });
      alert("Permissions saved successfully");
    } catch (error) {
      console.error("Error saving permissions", error);
      alert("Failed to save permissions");
    }
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row">
                  <div className="d-flex gap-2">
                    <div className="col-md-3">
                      <UserHeader data={'User Portal'}/>
                    </div>
                    <div className="col-md-9">
                      <div className="card">
                        <div className="card-body">

                          <form onSubmit={roleAssign}>
                            <div className="container py-5">
                              <h2 className="text-center fw-bold fs-2 mb-5" style={{ color: "#7b2cbf" }}>
                                🛡️ Role Permission Settings
                              </h2>

                              <div className="col-md-6 form-floating form-floating-outline mb-5">
                                <input type="text" className="form-control input-lowercase" name="name" placeholder="Username" />
                                <label>Username</label>
                                <span className="text-danger">{error?.name ?? ''}</span>

                              </div>

                              {entities.map((entity) => {
                                const allFields = entityFields[entity.id] || [];
                                const selectedFields = selectedPermissions[entity.id] || [];
                                const allSelected = selectedFields.length === allFields.length && allFields.length > 0;

                                return (
                                  <div
                                    key={entity.id}
                                    className="card mb-4 border-0 shadow rounded-4"
                                    style={{
                                      background: "rgba(255, 255, 255, 0.75)",
                                      backdropFilter: "blur(10px)",
                                    }}
                                  >
                                    <div className="card-header  d-flex justify-content-between align-items-center rounded-top-4 py-3 px-4 border-bottom">
                                      <h5 className="mb-0 text-capitalize fw-semibold text-primary">
                                        {entity.name} (ID: {entity.id})
                                      </h5>
                                      {allFields.length > 0 && (
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input text-primary"
                                            type="checkbox"
                                            id={`selectAll-${entity.id}`}
                                            checked={allSelected}
                                            onChange={() => handleSelectAll(entity.id)}
                                          />
                                          <label className="form-check-label text-primary" htmlFor={`selectAll-${entity.id}`}>
                                            Select All
                                          </label>
                                        </div>
                                      )}
                                    </div>

                                    <div className="card-body px-9 pt-3 pb-4">


                                      <div className="row g-3">
                                        {allFields.map((field, index) => (
                                          <div className="col-md-3" key={field + index}>
                                            <div className="form-check p-2 rounded-3  d-flex align-items-center">
                                              <input
                                                className="form-check-input me-2"
                                                type="checkbox"
                                                id={`${entity.id}-${field.id}`}
                                                checked={
                                                  selectedPermissions[entity.id]?.some((f) => f.id === field.id) || false
                                                }
                                                onChange={() => handleCheckboxChange(entity.id, field)}
                                              />
                                              <label
                                                className="form-check-label ms-2 text-capitalize fw-normal"
                                                htmlFor={`${entity.id}-${field.id}`}
                                              >
                                                {field.name}
                                              </label>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}

                              <div className="text-center mt-4">
                                <button
                                  type="submit"
                                  className="btn btn-primary px-5"
                                  disabled={loading}  // Disable the button while loading
                                >
                                  {loading ? (
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                  ) : (
                                    'Submit Permissions'
                                  )}
                                  {loading ? ' Submitting...' : ''}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </>

  );
};

export default RolePermissionForm;
